import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);
const KEY = "sg_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch {} }, [items]);

  // After a sign-in redirect triggered from a membership cart, reopen the cart so the
  // parent lands right back at checkout (cart is preserved in localStorage).
  useEffect(() => {
    try {
      if (localStorage.getItem("sg_open_cart") === "1") {
        localStorage.removeItem("sg_open_cart");
        if ((JSON.parse(localStorage.getItem(KEY)) || []).length) setOpen(true);
      }
    } catch {}
  }, []);

  const add = useCallback((it) => {
    setItems((prev) => {
      // Membership = subscription; only ONE allowed, and it never stacks qty.
      if (it.type === "membership") {
        const rest = prev.filter((p) => p.type !== "membership");
        return [...rest, { cover: null, ...it, qty: 1 }];
      }
      const ex = prev.find((p) => p.sku === it.sku);
      if (ex) return prev.map((p) => (p.sku === it.sku ? { ...p, qty: Math.min(20, p.qty + 1) } : p));
      return [...prev, { ...it, cover: it.cover || null, type: it.type || "", qty: 1 }];
    });
    setOpen(true);
  }, []);
  const remove = useCallback((sku) => setItems((prev) => prev.filter((p) => p.sku !== sku)), []);
  const setQty = useCallback((sku, qty) => setItems((prev) =>
    qty <= 0 ? prev.filter((p) => p.sku !== sku) : prev.map((p) => (p.sku === sku ? { ...p, qty: Math.min(20, qty) } : p))), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const membership = items.find((i) => i.type === "membership") || null;
  const gifts = items.filter((i) => i.type === "gift");
  const shopItems = items.filter((i) => i.type !== "membership" && i.type !== "gift");
  const shopSubtotal = shopItems.reduce((s, i) => s + i.price * i.qty, 0);
  const shopCount = shopItems.reduce((s, i) => s + i.qty, 0);
  const giftSubtotal = gifts.reduce((s, i) => s + i.price * i.qty, 0);
  const giftCount = gifts.reduce((s, i) => s + i.qty, 0);
  const dueToday = (membership ? membership.price : 0) + shopSubtotal + giftSubtotal;

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, subtotal, membership, gifts, giftSubtotal, giftCount, shopItems, shopSubtotal, shopCount, dueToday, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
